import { GetOrdersRequest } from '@/pages/Orders/Orders.interfaces';
import { PayloadAction, createSlice } from '@reduxjs/toolkit';

export interface IInitialState {
  orders: [];
  filters: GetOrdersRequest;
}

const initialState: IInitialState = {
  orders: [],
  filters: {
    limit: 10,
    offset: 0,
    dateBeg: null,
    dateEnd: null,
    filters: {},
  },
};

const ordersSlice = createSlice({
  name: 'registration',
  initialState,
  reducers: {
    setOrders: (state, action: PayloadAction<any>) => {
      state.orders = action.payload;
    },

    setFilters: (state, action: PayloadAction<GetOrdersRequest>) => {
      state.filters = action.payload;
    },
  },
});

export const { setOrders, setFilters } = ordersSlice.actions;

export default ordersSlice.reducer;
